/**
 * ThemeToggleButton
 * Compact icon-button variant of the dark mode toggle, for pages that don't
 * have a sidebar to host the full ThemeToggle (LandingPage, AuthPage).
 * Shares the same useDarkMode state/localStorage key as the sidebars.
 */
import React from 'react';

const ThemeToggleButton = ({ isDarkMode, onToggle, className = '', testId = 'theme-toggle-button' }) => {
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-label={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-pressed={isDarkMode}
      data-testid={testId}
      className={`inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full text-lg transition ${className}`}
    >
      <span aria-hidden="true">{isDarkMode ? '🌙' : '☀️'}</span>
    </button>
  );
};

export default ThemeToggleButton;
